import React from 'react';
import styled from 'styled-components';

import { BASIC_CHART_VIEWS } from '../../constants/event';
import CustomSelect from './Select';
import ChartOptions from './ChartOptions';

const ExecutionOptionsBarContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .view-title {
    margin-right: 5px;
  }
`;

const ExecutionOptionsBar = (props) => {
  const { options, onChangeView, selectStyle = {} } = props;
  const isChartView = BASIC_CHART_VIEWS.includes(options.view);
  return (
    <ExecutionOptionsBarContainer>
      {/* отображать данные пункты меню только в режиме чарта, так как в режиме таблицы они не имеют смысла */}
      {isChartView && <ChartOptions {...options} {...props} />}
      <div>
        <span className="view-title">View:</span>
        <CustomSelect
          allowClear={false}
          onChange={onChangeView}
          value={options.view}
          values={options.views}
          style={{ width: 'auto', minWidth: 80, ...selectStyle }}
          dropdownMatchSelectWidth={false}
          className="ant-select-border-bottom"
        />
      </div>
    </ExecutionOptionsBarContainer>
  );
};

export default ExecutionOptionsBar;
